<template>
  <b-sidebar
    id="sidebar-booking"
    :visible="isShowSidebar"
    aria-labelledby="sidebar-booking"
    shadow
    right
    :lazy="true"
    backdrop
    :no-enforce-focus="true"
    width="85vw"
    @hidden="hide"
  >
    <template #header>
      <b-row class="header-filter no-gutters">
        <b-col class="text-filter"> Add Booking</b-col>
      </b-row>
    </template>
    <div class="mb-5">
      <div v-if="isLoading">
        <OtherLoading />
      </div>
      <div class="text-normal" v-else>
        <div class="row p-3">
          <b-col v-if="id > 0">
            <span class="header-tablepage"> ID: </span>
            <span class="header-tablepage">{{ detail.prefix_id }}</span>
          </b-col>
          <b-col v-else>
            <span class="header-tablepage"> New Booking</span>
          </b-col>
          <b-col>
            <b-form-select
              v-model="selectedStatus"
              value-field="id"
              text-field="name"
              :options="statusOptions"
            ></b-form-select
          ></b-col>
        </div>

        <BookingDetailTab
          v-if="detail"
          :data="detail"
          :selectedStatus="selectedStatus"
          :branchList="branchList"
          :showFooter="false"
          :templateId="templateId"
          :fromTicket="true"
          @hide="afterCreateBooking"
          ref="bookingForm"
        />
      </div>
    </div>
    <template #footer>
      <div
        class="d-flex justify-content-between shadow align-items-center footer"
      >
        <div class="w-100">
          <b-button
            block
            variant="dark"
            class="text-light rounded-pill"
            @click.prevent="hide"
          >
            Cancel
          </b-button>
        </div>
        <div class="w-100">
          <b-button
            @click.prevent="$refs.bookingForm.checkForm()"
            block
            variant="light"
            id="handle-search-filter"
            class="text-body rounded-pill btn-main"
          >
            Save
          </b-button>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import InputText from "@/components/inputs/InputText.vue";
// import AutoComplete from "@/components/inputs/Autocomplete";

export default {
  name: "BookingFormSidebar",
  components: {
    OtherLoading,

    InputText,
    // AutoComplete,
    BookingDetailTab: () =>
      import("@/components/booking/detail/BookingDetailTab"),
  },
  props: {
    id: {
      required: true,
      type: Number,
    },
    templateId: {
      required: true,
      type: Number | String,
    },
    customer: {
      required: false,
      type: Object,
    },
  },
  data() {
    return {
      isShowSidebar: false,
      selectedCustomer: null,
      branchList: [],
      statusOptions: [],
      statusCampaign: null,
      isLoading: true,
      disabledPoint: false,
      selectedStatus: null,
      detail: {
        sale_branch: "",
        sale_user_guid: "",
        sale_branch_id: "",
        firstname_answer: "",
        lastname_answer: "",
        booking_service_list: [],
        booking_add_on_list: [],
        fields: [],
        description: [],
        bookingId: 0,
        status: "",
        booking_attachment_list: [],
      },
    };
  },

  computed: {},
  watch: {
    id: {
      async handler(newValue) {
        this.detail = {
          sale_branch: "",
          sale_user_guid: "",
          sale_branch_id: "",
          firstname_answer: "",
          lastname_answer: "",
          booking_service_list: [],
          booking_add_on_list: [],
          fields: [],
          description: [],
          bookingId: 0,
          status: "",
          booking_attachment_list: [],
        };
        if (newValue > 0) {
          await this.getFormDetail();
        }
      },
      deep: true,
      immediate: true,
    },
    templateId: {
      async handler(newValue) {
        if (this.id === 0) await this.getFormField();
      },
      deep: true,
      immediate: true,
    },
    customer: {
      async handler(newValue) {
        if (this.customer) {
          this.detail = {
            ...this.detail,
            telephone: this.customer.telephone,
            email: this.customer.email,
            username: this.customer.name,
            user_guid: this.customer.user_guid,
          };
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getBranchList();
  },
  methods: {
    async show() {
      this.isShowSidebar = true;
    },
    hide() {
      this.isShowSidebar = false;
    },
    afterCreateBooking(booking) {
      this.$emit("addBooking", booking, this.id);
      this.hide();
    },
    async getFormField() {
      try {
        await this.$store.dispatch("getBookingDetail", this.templateId);
        const data = this.$store.state.form.formDetail;

        if (data.result == 1) {
          this.detail.fields = data.detail.result.booking.fields;
          this.statusOptions = this.mappingStatus(
            data.detail.result.booking.options
          );
          this.selectedStatus = this.statusOptions[0].id;
        }
        this.isLoading = false;
      } catch (error) {}
    },
    async getFormDetail() {
      this.isLoading = true;
      await this.$store.dispatch("getBookingFormDetail", { id: this.id });
      let data = this.$store.state.form.campaignDetail;
      if (data && data.result == 1) {
        this.statusOptions = this.mappingStatus(data.detail.options);
        this.selectedStatus = data.detail.status;
        this.detail = data.detail;
        this.disabledPoint = data.detail.point > 0;
      }
      this.isLoading = false;
    },
    async getBranchList() {
      const res = await this.axios(`/booking/get_branch_list`);

      this.branchList = res.data.detail;
    },

    mappingStatus(options) {
      return options.map((item) => {
        return {
          id: item.booking_status_id,
          name: item.name,
          disabled: this.id == 0 ? false : item.changeable == 0,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .b-sidebar > .b-sidebar-header {
  font-size: 16px;
  display: block;
  padding: unset;
}
.header-filter {
  background-color: var(--theme-secondary-color);
  padding: 15px 0.5rem;
}
.text-filter {
  font-weight: 600;
}

.text-filter {
  font-weight: 600;
}

.w-100px {
  width: 101px !important;
  min-width: 0 !important;
}

.footer {
  ::v-deep .rounded-pill {
    border-radius: 0px !important;
  }
  ::v-deep .btn-main,
  .btn-mains button {
    width: 100% !important;
  }
}

::v-deep .btn-main,
.btn-mains button {
  background-color: var(--primary-color) !important;
  border: 1px solid var(--primary-color);
}
</style>
